module.exports = __webpack_public_path__ + "img/pay_paypal.d418d2cf.png";